<template>


    <m-g4>

      <template #pr-1>

        <slot name="pr-1"/>
      </template>


      <template #pl-1>

        <m-g1>

          <template #pr-1>

            <slot name="pl-1"/>

          </template>

          <template #pl-1>

            <slot name="pl-2"/>

          </template>



        </m-g1>


        <m-g1>

          <template #pr-1>

            <slot name="pl-3" />

          </template>

          <template #pl-1>
            <slot name="pl-4" />

          </template>


        </m-g1>


      </template>


    </m-g4>


</template>

<script>
export default {
  name: "S4"
}
</script>

<style scoped>

</style>